import TemplateView from '../TemplateView'

export default class ScrollToTopButton extends TemplateView {
    constructor({
        onClickCb = () => {},
        fadingHeight = 0,
        scrollToTopButtonAdditionalClass = '',
    } = {}) {
        super()

        this.params = {
            fadingHeight,
            scrollToTopButtonAdditionalClass,
        }

        this.callbacks = {
            onClickCb,
        }

        this.isShown = false
    }

    templateHtml() {
        return "<div class='scrollToTopButton <%-scrollToTopButtonAdditionalClass%>'></div>"
    }

    templateModel() {
        return {
            scrollToTopButtonAdditionalClass: this.params.scrollToTopButtonAdditionalClass
        }
    }

    afterRender() {
        this.bindClick(this.callbacks.onClickCb)

        this.hide()
    }

    updateVisibility(verticalScrollPosition) {
        //stops fadeTo
        this.$el.stop(true)

        if (verticalScrollPosition === 0 && this.isShown)
            this.hide()

        if (verticalScrollPosition !== 0 && !this.isShown)
            this.show()

        this._updateOpacity(verticalScrollPosition)
    }

    fadeOut(duration = 1) {
        this.$el.fadeTo(duration, 0, () => this.hide())
    }

    hide() {
        super.hide()
        this.isShown = false
    }

    show() {
        super.show();
        this.isShown = true
    }

    _updateOpacity(y) {
        let opacity = Math.abs(y / this.params.fadingHeight)
        if (opacity > 1)
            opacity = 1
        this.$el.css('opacity', opacity)
    }
}


// WEBPACK FOOTER //
// ./web/js/components/ScrollToTopButton.js